import {Routes} from '@angular/router';
import {VnaClientListComponent} from './management/components/vna-client-list/vna-client-list.component';


export const CLIENT_ROUTES: Routes = [
    {path:'clients', component: VnaClientListComponent}


];


// WEBPACK FOOTER //
// /var/www/backend/src/app/client/client.routes.ts